import {
  OutstandingItemSource,
  OutstandingItemStatus,
  OutstandingService,
  VDriveStatus,
} from '@vgrubs/components';
import { DateTime } from 'luxon';

export const SERVICE_LABELS: Record<OutstandingService, string> = {
  vDrive: 'vDrive',
  saas: 'SaaS',
};

/** Where an item came from, in words support can repeat to an owner. */
export const SOURCE_LABELS: Record<OutstandingItemSource, string> = {
  failedAch: 'Bank payment failed',
  achUnavailable: 'No active bank account to charge',
  backupCardCharge: 'Charged to the vGrubs backup card',
  vDriveCardCharge: 'Spent on the vGrubs vDrive card',
  legacyDebt: 'Debt recorded before the ledger',
  manual: 'Added by an admin',
};

export const STATUS_LABELS: Record<OutstandingItemStatus, string> = {
  open: 'Open',
  paid: 'Paid',
  writtenOff: 'Written off',
};

export const formatDay = (iso: string | null | undefined) =>
  iso ? DateTime.fromISO(iso).toFormat('MMM d, yyyy') : '-';

export const formatDayTime = (iso: string | null | undefined) =>
  iso ? DateTime.fromISO(iso).toFormat('MMM d, yyyy - h:mm a') : '-';

/** "in 22 days", "today", "3 days ago" - for a pause or a sunset date. */
export const relativeDays = (iso: string) => {
  const days = Math.round(
    DateTime.fromISO(iso)
      .startOf('day')
      .diff(DateTime.now().startOf('day'), 'days').days
  );
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days === -1) return 'yesterday';
  return days > 0 ? `in ${days} days` : `${-days} days ago`;
};

/**
 * A location's vDrive status in words. A function rather than a map: the enum
 * is a barrel value, and reading one at module top level breaks eagerly
 * loaded files.
 */
export const vDriveStatusLabel = (status: VDriveStatus) => {
  switch (status) {
    case VDriveStatus.active:
      return 'Active';
    case VDriveStatus.inProgress:
      return 'In progress';
    case VDriveStatus.inactive:
      return 'Inactive';
    case VDriveStatus.rejected:
      return 'Rejected';
    case VDriveStatus.disabled:
      return 'Disabled';
    default:
      return status;
  }
};
